import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import styles from './Icons.module.css';
import { IconsType, PyramydAirIconProps } from './types';

const PyramydAirIcons = (props: PropsWithChildren<PyramydAirIconProps>) => {
  const { iconType, className, children } = props;

  const mapIconsStyle = (icon: IconsType): string => {
    const pyramidIconsStyle: Record<string, string> = {
      personIcon: styles.personIcon,
      shoppingCartIcon: styles.shoppingCartIcon,
    };
    return pyramidIconsStyle[icon];
  };

  return <span className={clsx('font-serif', styles.icon, className, mapIconsStyle(iconType))}>{children}</span>;
};

export default PyramydAirIcons;
